<template>

  <div>
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="12"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h1 class="custom-header-title float-left pr-1 mb-0">
              Entitlements
            </h1>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <!-- Table Container Card -->
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left booking_content_wrapper mb-2"
        cols="12"
        md="12"
      >
        <b-dropdown
          v-if="isMobile()"
          :text="currentTabTitle"
          variant="outline-primary"
        >
          <b-dropdown-item
            v-for="(tab, index) in pageTabs"
            :key="index"
            @click="changeRoute(tab.param)"
          >
            {{ tab.title }} ({{ tab.count }})
          </b-dropdown-item>
        </b-dropdown>
        <b-tabs
          pills
          class="booking__content"
          :nav-class="[isMobile() ? 'd-none' : '']"
        >
          <!-- Tab: Account -->
          <b-tab
            :active="$route.params.type == 'redeemable'"
            lazy
            @click="changeRoute('redeemable')"
          >
            <template #title>
              <span class="d-none d-sm-inline">Redeemable <span class="rounded-number">{{ redeemableCount }}</span></span>
            </template>
            <redeemable-entitlement
              class="mt-2 pt-75"
              @emitCountEntitlement="countEntitlements"
            />
          </b-tab>

          <!-- Tab: Information -->
          <b-tab
            :active="$route.params.type == 'used'"
            lazy
            @click="changeRoute('used')"
          >
            <template #title>
              <span class="d-none d-sm-inline">Used <span class="rounded-number">{{ usedCount }}</span></span>
            </template>
            <used-entitlement
              class="mt-2 pt-75"
              @emitCountEntitlement="countEntitlements"
            />
          </b-tab>

          <!-- Tab: Information -->
          <b-tab
            :active="$route.params.type == 'expired'"
            lazy
            @click="changeRoute('expired')"
          >
            <template #title>
              <span class="d-none d-sm-inline">Expired <span class="rounded-number">{{ expiredCount }}</span></span>
            </template>
            <expired-entitlement
              class="mt-2 pt-75"
              @emitCountEntitlement="countEntitlements"
            />
          </b-tab>

          <!-- Tab: Information -->
          <b-tab
            :active="$route.params.type == 'cancelled'"
            lazy
            @click="changeRoute('cancelled')"
          >
            <template #title>
              <span class="d-none d-sm-inline">Cancelled <span class="rounded-number">{{ cancelledCount }}</span></span>
            </template>
            <cancelled-entitlement
              class="mt-2 pt-75"
              @emitCountEntitlement="countEntitlements"
            />
          </b-tab>

          <b-tab
            :active="$route.params.type == 'all-entitlement'"
            lazy
            @click="changeRoute('all-entitlement')"
          >
            <template #title>
              <span class="d-none d-sm-inline">All Entitlement <span class="rounded-number">{{ allCount }}</span></span>
            </template>
            <all-entitlement
              class="mt-2 pt-75"
              @emitCountEntitlement="countEntitlements"
            />
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BTab, BTabs, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import AllEntitlement from './all-entitlements/AllEntitlement.vue'
import RedeemableEntitlement from './redeemable-entitlements/RedeemableEntitlement.vue'
import UsedEntitlement from './used-entitlements/UsedEntitlement.vue'
import ExpiredEntitlement from './expired-entitlements/ExpiredEntitlement.vue'
import CancelledEntitlement from './cancelled-entitlements/CancelledEntitlement.vue'

export default {
  components: {
    BRow,
    BCol,
    BTab,
    BTabs,
    BDropdown,
    BDropdownItem,

    AllEntitlement,
    RedeemableEntitlement,
    UsedEntitlement,
    ExpiredEntitlement,
    CancelledEntitlement,
  },
  data() {
    return {
      allCount: 0,
      redeemableCount: 0,
      usedCount: 0,
      expiredCount: 0,
      cancelledCount: 0,
      currentTabTitle: '',
      pageTabs: [
        {
          title: 'Redeemable',
          param: 'redeemable',
          count: 0,
        },
        {
          title: 'Used',
          param: 'used',
          count: 0,
        },
        {
          title: 'Expired',
          param: 'expired',
          count: 0,
        },
        {
          title: 'Cancelled',
          param: 'cancelled',
          count: 0,
        },
        {
          title: 'All Entitlements',
          param: 'all-entitlement',
          count: 0,
        },
      ],
    }
  },
  watch: {
    $route() {
      const param = this.$route.params.type
      const currentTab = this.pageTabs.find(o => o.param === param)
      if (currentTab) {
        this.currentTabTitle = `${currentTab.title} (${currentTab.count})`
      }
    },
  },
  beforeMount() {
    this.countEntitlements()
  },

  methods: {
    changeRoute(param) {
      this.$router.replace({
        params: {
          type: param,
        },
        query: {},
      })
    },
    countEntitlements() {
      this.$http.get('customer/entitlements/counts')
        .then(response => {
          this.allCount = response.data.allCount
          this.redeemableCount = response.data.redeemableCount
          this.usedCount = response.data.usedCount
          this.expiredCount = response.data.expiredCount
          this.cancelledCount = response.data.cancelledCount

          this.pageTabs.forEach(element => {
            if (element.title === 'All Entitlements') {
              // eslint-disable-next-line no-param-reassign
              element.count = this.allCount
            } else if (element.title === 'Redeemable') {
              // eslint-disable-next-line no-param-reassign
              element.count = this.redeemableCount
            } else if (element.title === 'Used') {
              // eslint-disable-next-line no-param-reassign
              element.count = this.usedCount
            } else if (element.title === 'Expired') {
              // eslint-disable-next-line no-param-reassign
              element.count = this.expiredCount
            } else if (element.title === 'Cancelled') {
              // eslint-disable-next-line no-param-reassign
              element.count = this.cancelledCount
            }
          })

          const param = this.$route.params.type

          const currentTab = this.pageTabs.find(o => o.param === param)
          if (currentTab) {
            this.currentTabTitle = `${currentTab.title} (${currentTab.count})`
          }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
  },
}
</script>

<style scoped>
  .rounded-number {
    height: 24px;
    width: 24px;
    background-color: #FFFFFF;
    border-radius: 50%;
    color:#104D9D;
  }
</style>
